export const styles = {
  paper: {
    padding: "16px !important",
    width: "360px",
    borderRadius: "8px",
  },
};
